"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { ArrowRight } from "lucide-react";
export default function NaturalColorsExplosion() {
  const particles = Array.from({
    length: 15
  });
  return <section data-section-id="222610" id="hero" className="relative w-full min-h-screen bg-background overflow-hidden flex flex-col lg:flex-row">
      {}
      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes float-petal {
          0% { transform: translateY(10vh) translateX(0) rotate(0deg) scale(0.8); opacity: 0; }
          20% { opacity: 0.4; }
          80% { opacity: 0.4; }
          100% { transform: translateY(-100vh) translateX(20vw) rotate(360deg) scale(1.2); opacity: 0; }
        }
        .animate-petal {
          animation: float-petal 15s linear infinite;
        }
      `
    }} />

      {}
      <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden" aria-hidden="true">
        {particles.map((_, i) => <div key={i} data-index={i} className="absolute animate-petal rounded-[40%_60%_60%_40%_/_40%_40%_60%_60%] bg-primary/10 backdrop-blur-sm" style={{
        width: `${Math.random() * 20 + 10}px`,
        height: `${Math.random() * 20 + 10}px`,
        left: `${Math.random() * 100}%`,
        bottom: `-5%`,
        animationDelay: `${Math.random() * 15}s`,
        animationDuration: `${Math.random() * 10 + 15}s`
      }} />)}
      </div>

      {}
      <div className="relative w-full lg:w-[60%] h-[50vh] lg:h-auto min-h-[50vh] lg:min-h-screen z-10">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/studio_recording_session_sp.png" alt="Estúdio de podcast moderno em Pinheiros" className="absolute inset-0 w-full h-full object-cover object-center" />
        {}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent to-background/20 lg:to-transparent" />
      </div>

      {}
      <div className="relative w-full lg:w-[40%] flex items-center justify-center p-6 sm:p-10 lg:p-12 z-20 -mt-20 lg:mt-0 lg:-ml-24">
        <Card className="w-full max-w-lg bg-background/95 backdrop-blur-md shadow-2xl border-border/30 rounded-3xl overflow-hidden animate-in fade-in slide-in-from-bottom-5 duration-1000">
          <CardHeader className="pb-4">
            <CardTitle className="font-default text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground leading-tight tracking-tighter">
              Estúdio de podcast em Pinheiros e <br className="hidden sm:block" />
              <span className="text-primary font-bold">produtora de vídeo</span>
            </CardTitle>
          </CardHeader>
          <CardContent className="flex flex-col gap-8">
            <CardDescription className="font-default text-lg sm:text-xl text-muted-foreground leading-relaxed">
              Transforme sua mensagem em autoridade digital com infraestrutura de ponta e estratégia audiovisual completa no coração de São Paulo.
            </CardDescription>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="w-full sm:w-auto text-base h-14 px-8 rounded-full bg-primary text-primary-foreground shadow-lg hover:shadow-primary/40 transition-all hover:-translate-y-1">
                <Link to="https://wa.me/5511969100007">
                  Agendar Gravação
                  <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}